import React from "react";
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

const Header = () => {

    // hooks
    const { isAuth } = useSelector((state) => state.auth);

    return (
        <header className="relative z-10 px-6 py-6">
            <div className="max-w-7xl mx-auto flex items-center justify-between">
                <div className="flex items-center gap-3">
                    <Link to="/" className="w-12 h-12 bg-gradient-to-br from-cyan-400 to-blue-600 rounded-lg flex items-center justify-center">
                        <div className="w-8 h-8 border-4 border-white rounded-full"></div>
                    </Link>
                    <Link to="/">
                        <h1 className="text-white text-2xl font-bold">GATEWAY</h1>
                        <p className="text-cyan-400 text-sm font-semibold">PROMOTERS</p>
                    </Link>
                </div>
                {
                    isAuth ? (
                        <div className="flex gap-4">
                            <Link to="/dashboard" className="px-6 py-2 bg-gradient-to-r from-cyan-500 to-blue-600 text-white rounded-lg hover:shadow-lg hover:shadow-cyan-500/50 transition-all">
                                Dashboard
                            </Link>
                        </div>
                    ) : (
                        <div className="flex gap-4">
                            <Link to="/login" className="px-6 py-2 text-white hover:text-cyan-400 transition-colors">
                                Login
                            </Link>
                            <Link to="/register" className="px-6 py-2 bg-gradient-to-r from-cyan-500 to-blue-600 text-white rounded-lg hover:shadow-lg hover:shadow-cyan-500/50 transition-all">
                                Register
                            </Link>
                        </div>
                    )
                }
            </div>
        </header>
    )
}

export default Header;